import { getConfig } from '@/shared/config'
import { cn } from './primitives'

/**
 * The build identifier, as ops needs to read it.
 *
 * Version and date together, because a version alone cannot distinguish two
 * deploys of the same unreleased number — which is exactly the situation
 * during a cutover, when someone asks "is the fix live yet?".
 */
export const BUILD_LABEL = `v${__APP_VERSION__} · ${__BUILD_DATE__}`

export function AppFooter({ className }: { className?: string }) {
  const { companyName } = getConfig()
  // Rendered, not baked in: a copyright year frozen at build time is wrong
  // every January until someone redeploys.
  const year = new Date().getFullYear()

  return (
    <footer
      className={cn(
        'flex flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 py-5 text-center text-xs text-gray-500',
        className,
      )}
    >
      <span>
        © {year} {companyName}
      </span>
      <span aria-hidden="true" className="text-gray-400">
        ·
      </span>
      <span>Dikembangkan oleh PT Primus Indonesia</span>
      <span aria-hidden="true" className="text-gray-400">
        ·
      </span>
      <span className="font-mono tabular-nums">{BUILD_LABEL}</span>
    </footer>
  )
}
